/*
 * @Author: ninggangliu
 * @Date: 2022-03-11 10:24:33
 * @LastEditors: ninggangliu
 * @LastEditTime: 2022-03-28 08:56:45
 * @FilePath: /web_rms/src/api/http.js
 */
import axios from 'axios';
import Router from '@/router/index';
import { MessageBox, Message } from "element-ui";

const requestUrl = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
})

// 请求前
requestUrl.interceptors.request.use(function (config) {
    const token = JSON.parse(window.sessionStorage.getItem('userInfo')) ? JSON.parse(window.sessionStorage.getItem('userInfo')).token2 : ''
    config.headers["Access-Control-Allow-Origin"] = "*"
    config.headers.common['Authorization'] = token;
    config.headers['clientType'] = 'WIMS'
    config.headers['accessToken'] = token
    return config;
}, function (err) {
    return Promise.reject(err)
})

// 请求后
requestUrl.interceptors.response.use(function (response) {
    const code = response.data.code || 200;
    const msg = response.data.msg;
    if (code === 505 || code === 401 || code === "401") {
        Message.warning('登陆状态已过期，请重新登陆')
        window.sessionStorage.removeItem('userInfo')
        Router.replace('/login');
        return Promise.reject(new Error('登陆状态已过期'))
    }
    return response.data
}, error => {
    let { message } = error;
    if (message === "NetWork Error") {
        message = '后端接口连接异常'
    } else if (message.includes('timeout')) {
        message = '系统几口请求超时'
    } else if (message.includes("Request failed with status code")) {
        message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    const noErrorTip = error.config?.noErrorTip;
    if (!noErrorTip) {
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
    } else {
        console.warn('请求失败:', message);
    }
    return Promise.reject(error)
});

// 导出
export default requestUrl;
